package meineglasfaser.frontend.common.components.widgets

import androidx.compose.runtime.Composable
import meineglasfaser.api.ShopPriceGroup
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Small
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun PriceGroupView(price: ShopPriceGroup, includesTax: Boolean? = null) {
    Div({ classes("flex-column") }) {
        if (price.monthly.value > 0.0) {
            Span {
                Text(price.monthly.displayStrCurrency())
                Text(" / Monat")
            }
        }
        if (price.yearly.value > 0.0) {
            Span {
                Text(price.yearly.displayStrCurrency())
                Text(" / Jahr")
            }
        }
        if (price.once.value > 0.0) {
            Span {
                Text(price.once.displayStrCurrency())
                Text(" einmalig")
            }
        }
        includesTax?.let { includesTax ->
            Small {
                if (includesTax) {
                    Text("inkl. USt.")
                } else {
                    Text("exkl. USt.")
                }
            }
        }
    }
}
